
    import './styles.scoped.css';
    export default {
  "dropdown-content-wrapper": "awsui_dropdown-content-wrapper_qwoo0_4mebf_93",
  "awsui-motion-fade-in-dropdown": "awsui_awsui-motion-fade-in-dropdown_qwoo0_4mebf_1",
  "refresh": "awsui_refresh_qwoo0_4mebf_114",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_qwoo0_4mebf_1",
  "root": "awsui_root_qwoo0_4mebf_143",
  "interior": "awsui_interior_qwoo0_4mebf_179",
  "dropdown": "awsui_dropdown_qwoo0_4mebf_93",
  "use-portal": "awsui_use-portal_qwoo0_4mebf_190",
  "is-empty": "awsui_is-empty_qwoo0_4mebf_235",
  "dropdown-drop-up": "awsui_dropdown-drop-up_qwoo0_4mebf_238",
  "with-limited-width": "awsui_with-limited-width_qwoo0_4mebf_242",
  "dropdown-drop-left": "awsui_dropdown-drop-left_qwoo0_4mebf_245",
  "dropdown-drop-right": "awsui_dropdown-drop-right_qwoo0_4mebf_248",
  "occupy-entire-width": "awsui_occupy-entire-width_qwoo0_4mebf_251",
  "stretch-beyond-trigger-width": "awsui_stretch-beyond-trigger-width_qwoo0_4mebf_254",
  "hide-upper-border": "awsui_hide-upper-border_qwoo0_4mebf_258",
  "open": "awsui_open_qwoo0_4mebf_265",
  "nowrap": "awsui_nowrap_qwoo0_4mebf_274",
  "dropdown-content": "awsui_dropdown-content_qwoo0_4mebf_93",
  "stretch-trigger-height": "awsui_stretch-trigger-height_qwoo0_4mebf_285"
};
  